var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstimate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20633",
    "data-name": "Group 20633",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.218,
    height: 20.018,
    viewBox: "0 0 19.218 20.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20632",
    "data-name": "Group 20632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20657",
    "data-name": "Path 20657",
    d: "M26.816,16.406h-1.7A7.591,7.591,0,0,0,17.607,10a.4.4,0,0,0-.4.4v6.806H10.4a.4.4,0,0,0-.4.4,7.616,7.616,0,0,0,7.607,7.607,7.4,7.4,0,0,0,.8-.049v2.451a1.2,1.2,0,0,0,1.2,1.2h7.207a1.2,1.2,0,0,0,1.2-1.2V17.607A1.2,1.2,0,0,0,26.816,16.406Zm-9.208,8.007a6.815,6.815,0,0,1-6.795-6.406h6.795a.4.4,0,0,0,.4-.4V10.812A6.792,6.792,0,0,1,24.3,16.406H19.609a1.2,1.2,0,0,0-1.2,1.2v6.751A6.573,6.573,0,0,1,17.607,24.413Zm9.609,3.2a.4.4,0,0,1-.4.4H19.609a.4.4,0,0,1-.4-.4V17.607a.4.4,0,0,1,.4-.4h7.207a.4.4,0,0,1,.4.4Z",
    transform: "translate(-8.799 -8.799)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20658",
    "data-name": "Path 20658",
    d: "M41.006,30H35.4a.4.4,0,0,0-.4.4v2a.4.4,0,0,0,.4.4h5.605a.4.4,0,0,0,.4-.4v-2A.4.4,0,0,0,41.006,30Zm-.4,2H35.8V30.8h4.8Z",
    transform: "translate(-23.79 -20.792)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20659",
    "data-name": "Path 20659",
    d: "M15.007,14.607V7.4a.4.4,0,0,0-.4-.4A7.616,7.616,0,0,0,7,14.607a.4.4,0,0,0,.4.4h7.207A.4.4,0,0,0,15.007,14.607ZM10.092,9.526a6.842,6.842,0,0,1,.713-.557l3.4,3.4v1.27Zm2.314-1.358,1.8,1.8v1.27L11.519,8.55A6.755,6.755,0,0,1,12.407,8.168Zm1.8.668-.9-.9a6.766,6.766,0,0,1,.9-.121ZM9.526,10.092l4.114,4.114h-1.27l-3.4-3.4A6.842,6.842,0,0,1,9.526,10.092Zm.442,4.114-1.8-1.8a6.759,6.759,0,0,1,.382-.887l2.688,2.688Zm-2.035-.9.9.9H7.812A6.763,6.763,0,0,1,7.933,13.3Z",
    transform: "translate(-7 -7)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20660",
    "data-name": "Path 20660",
    d: "M36.2,40h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,0,0,0-.8Z",
    transform: "translate(-23.79 -26.788)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20661",
    "data-name": "Path 20661",
    d: "M48.2,40h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,1,0,0-.8Z",
    transform: "translate(-30.985 -26.788)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20662",
    "data-name": "Path 20662",
    d: "M42.2,40h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,0,0,0-.8Z",
    transform: "translate(-27.387 -26.788)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20663",
    "data-name": "Path 20663",
    d: "M36.2,45h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,0,0,0-.8Z",
    transform: "translate(-23.79 -29.786)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20664",
    "data-name": "Path 20664",
    d: "M48.2,45h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,1,0,0-.8Z",
    transform: "translate(-30.985 -29.786)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20665",
    "data-name": "Path 20665",
    d: "M42.2,45h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,0,0,0-.8Z",
    transform: "translate(-27.387 -29.786)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20666",
    "data-name": "Path 20666",
    d: "M36.2,50h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,0,0,0-.8Z",
    transform: "translate(-23.79 -32.784)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20667",
    "data-name": "Path 20667",
    d: "M48.2,50h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,1,0,0-.8Z",
    transform: "translate(-30.985 -32.784)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20668",
    "data-name": "Path 20668",
    d: "M42.2,50h-.8a.4.4,0,1,0,0,.8h.8a.4.4,0,0,0,0-.8Z",
    transform: "translate(-27.387 -32.784)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimate);
export default __webpack_public_path__ + "static/media/Estimate.43c1ec7efe69095fb88c88f030747346.svg";
export { ForwardRef as ReactComponent };